export function setupCollabContentChangeGate(localEditPendingRef: { current: boolean }, onContentChange: (markdown: string) => void) {
  return (markdown: string) => {
    if (!localEditPendingRef.current) {
      return;
    }

    localEditPendingRef.current = false;
    onContentChange(markdown);
  };
}
